import React, { useState, useEffect } from 'react';
import { createUseStyles } from 'react-jss';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import DetailsCard from './TwigDetails/DetailsCard';
import Trends from './TwigDetails/Trends';
import { getTrendingTwigs } from '../services/TwigService';
import Loader from '../components/Loader';
import { Twig } from '../types';
import { Helmet } from 'react-helmet'
import { setMetaData } from '../services/helpers';
import BreadCrumb from '../components/BreadCrumb';
import clsx from 'clsx';
import { pageTrack } from '../services/mixpanelService';

export interface TwigDetailsProps {
  twig: Twig;
}

const TwigDetails: React.FC<TwigDetailsProps> = ({ twig }) => {
  const [loadingTrends, setLoadingTrends] = useState(true);
  const [trendingTwigs, setTrendingTwigs] = useState<Twig[]>([]);
  let BreadCrumbArray: any[] = []
  if (twig.category)
    BreadCrumbArray.push({ type: "categoryId", id: twig.category.id, label: twig.category.name })
  if (twig.subCategory && twig.category)
    BreadCrumbArray.push({ type: "subcategoryId", category_id: twig.category.id, id: twig.subCategory.id, label: twig.subCategory.name })
  BreadCrumbArray.push({ type: "twig", id: twig.uniqueName, label: twig.uniqueName })
  useEffect(() => {
    (async () => {
      setLoadingTrends(true);
      try {
        const response = await getTrendingTwigs();
        setTrendingTwigs(response);
        pageTrack("twig_details_screen")
      } catch (e) { }
      setLoadingTrends(false);
    })();
  }, []);

  const classes = useStyles();

  setMetaData({ "title": twig.uniqueName + ' twigBIG | Social eCommerce Marketplace in Beauty and Fashion', "description": twig.description, "image": twig.mediaThumbUrl, "url": window.location.href })
  return (
    <>
      <Helmet>
        <title>{twig.uniqueName}| twigBIG | Social eCommerce Marketplace in Beauty and Fashion</title>
        <meta property="og:description" content={<h1>{twig.uniqueName}</h1> + '| twigBIG | Social eCommerce Marketplace in Beauty and Fashion'} />
        <script type="application/ld+json">
          {
          `{
            "@context": "https://schema.org",
            "@type": "Product",
            "description": "${twig.product.description}",
            "name": "${twig.product.name}",
            "image": "${twig.product.photo}",
            "brand": "${twig.product.brand?.name}",

            "review": [
              {
                "@type": "Review",
                "author": "${twig.user.username}",
                "datePublished": "${twig.createdAt}",
                "reviewBody": "${twig.description}",
                "name": "${twig.uniqueName}",
                "image":"${twig.mediaThumbUrl}",
                "interactionStatistic": [
                  {
                    "@type": "InteractionCounter",
                    "interactionService": {
                      "@type": "WebSite",
                      "name": "twigBig",
                      "url": "https://twigbig.com/"
                    },
                    "interactionType": "https://schema.org/LikeAction",
                    "userInteractionCount": "${twig.favorites}"
                  },
                  {
                    "@type": "InteractionCounter",
                    "interactionService": {
                      "@type": "SoftwareApplication",
                      "name": "TwigBig",
                      "url": "https://play.google.com/store/apps/details?id=com.twigbig.app"
                    },
                    "interactionType": "https://schema.org/LikeAction",
                    "userInteractionCount": "${twig.favorites}"
                  }
                   ]
              }
            ]
          }`
          }




          </script>
      </Helmet>
      <div className={classes.breadCrumb}>
        <BreadCrumb children={BreadCrumbArray}></BreadCrumb>
      </div>
      <Container className={clsx(classes.customContainer, 'pt-5')} fluid>

        <Row className={classes.row}>
          <Col xs={12} lg={8}>
            <div className={classes.detailsContainer}>
              <DetailsCard twig={twig} />
            </div>
          </Col>
          {loadingTrends || trendingTwigs.length > 0 ? (
            <Col xs={12} lg={4} xl={{ span: 3 }} className="ml-xl-4 p-0">
              <div className={classes.trendsContainer}>
                
                <Loader className={classes.loader} loading={loadingTrends} center>
                  {() => <Trends trends={trendingTwigs} />}
                </Loader>
              </div>
            </Col>
          ) : null}
        </Row>
      </Container>
    </>
  );
};

const useStyles = createUseStyles({
  fullPage: {
    minHeight: '70vh',
    display: 'flex',
    flexDirection: 'column',
  },
  customContainer: {},
  '@media (max-width: 768px)': {
    customContainer: {
      padding: "0px !important"
    },
    breadCrumb: {
      display: "none"
    },
    container: {}

  },
  breadCrumb: {
    margin: "0px 20px"
  },
  row: {
    justifyContent: 'center',
  },
  detailsContainer: {
    maxWidth: '815px',
    margin: 'auto',
  },
  trendsContainer: {
    position: "sticky",
    top: "0",
    '@media screen and (max-width: 1024px)': {
      marginTop: '40px',
      marginLeft: '15px',
      marginRight: '15px',
    },
  },
  loader: {
    minHeight: '50vh',
  },
});

export default TwigDetails;
